module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2d"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/section1"
    }
  }, [_vm._v("SECTION ONE: LET THE COWS COME HOME! FOOLPROOF SUBSTITUTIONS FOR DAIRY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("Chapter 1 How To Substitute for DAIRY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1sec1"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 How To Substitute for CHEESE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/section2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION TWO: MAKE THE CHICKENS SMILE! FOOLPROOF SUBSTITUTIONS FOR EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 How to Substitute for EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/section3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION THREE: KEEP THE FARM ANIMALS FLOURISHING! FOOLPROOF SUBSTITUTIONS FOR MEAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 How to Substitute for BEEF, CHICKEN, PORK, and SEAFOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/section4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION FOUR: LEAVE THE BEES TO BUZZ! FOOLPROOF SUBSTITUTIONS FOR ANIMAL BY-PRODUCTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 How to Substitute for HONEY and GELATIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/section5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION FIVE: LET YOUR BODY REJOICE! FOOLPROOF SUBSTITUTIONS FOR GLUTEN, SOY, REFINED SUGAR, AND FAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 How to Substitute for GLUTEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 How to Substitute for Soy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 How to Substitute for REFINED SUGAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 How to Substitute for FAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/section6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION SIX: ENJOY KITCHEN SUCCESS! THE COMPLETE CHART OF VEGAN FOOD SUBSTITUTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0